import { Directive, OnInit, ElementRef } from '@angular/core';

@Directive({
  selector: '[appScrollReveal]'
})
export class ScrollRevealDirective implements OnInit {

  /**
   * Scroll Reveal
   */
  private _sr: scrollReveal.ScrollRevealObject;

  /**
   * Constructor
   *
   * @param _elementRef
   */
  constructor(private _elementRef: ElementRef) {
    this._sr = ScrollReveal({ reset: false });
  }

  /**
   * Init
   */
  ngOnInit() {
    this._sr.reveal(this._elementRef.nativeElement, { duration: 500 }, 50);
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/directives/scroll-reveal.directive.ts